<template>
    <div id="nav">
        <v-toolbar fixed app dark color="primary">
            <v-spacer></v-spacer>
            <v-toolbar-title><img src="/img/logo.png" :alt="title" aspect-ratio="1" height="64px" hlt-logo></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-side-icon>
                <LangSelector/>
            </v-toolbar-side-icon>
        </v-toolbar>
    </div>
</template>

<script>
    import LangSelector from "../common/LangSelector.vue";

    export default {
        name: "PatientNavigation",
        components: {LangSelector},
        data: () => ({
            title: window.appName,
        })
    }
</script>
